document.addEventListener('DOMContentLoaded', () => {

    const HAMBURGUER = document.getElementById('hamburguer-icon')
    const CLOSE_MENU = document.getElementById('close-mobile')
    const MOBILE_MENU = document.getElementById('mobile-menu')

    HAMBURGUER.addEventListener( 'click', () => {
        MOBILE_MENU.classList.toggle('open')
    })

    CLOSE_MENU.addEventListener( 'click', () => {
        MOBILE_MENU.classList.toggle( 'open' )
    })
    
}, true)